import { render, staticRenderFns } from "./DictTypeListTable.vue?vue&type=template&id=16eb0045&scoped=true&"
import script from "./DictTypeListTable.vue?vue&type=script&lang=js&"
export * from "./DictTypeListTable.vue?vue&type=script&lang=js&"
import style0 from "./DictTypeListTable.vue?vue&type=style&index=0&id=16eb0045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eb0045",
  null
  
)

export default component.exports